import {
  getFromLocalStorage,
  removeFromLocalStorage,
  setLocalStorage,
} from '../helpers/local-storage.helpers'
import { getClientsideQueryString } from '../helpers/get-clientside-query-string.helpers'

interface GfSaveFormHelper {
  id: string
  expiry: number
  fieldValues: any
}

export const gfMakeSaveFormId = (currentForm, destination) => {
  const uid = getClientsideQueryString('uid')
  if (uid) return `${currentForm.id}-${currentForm.title}-${destination}-${uid}`
  return `${currentForm.id}-${currentForm.title}-${destination}`
}

export const gfSaveForm = ({ id, expiry, fieldValues }: GfSaveFormHelper) => {
  const expirySeconds =
    typeof expiry === 'string' ? parseInt(expiry) * 1000 : expiry * 1000
  const expiryTimeStamp = Date.now() + expirySeconds
  setLocalStorage(id, { id, expiry: expiryTimeStamp, fieldValues })
}

export const gfRetrieveSavedForm = (id: GfSaveFormHelper['id']) => {
  const formData: GfSaveFormHelper = getFromLocalStorage(id)

  if (!formData) return null
  const secondsToExpiry = Date.now() - formData.expiry
  if (secondsToExpiry > 0) return null
  if (!formData.fieldValues) return null
  return formData.fieldValues
}

export const gfClearPreviouslySavedForm = (id: GfSaveFormHelper['id']) => {
  removeFromLocalStorage(id)
}
